export default __webpack_public_path__ + "static/media/jessicapeony_nine.49f10f3f.JPG";